import * as ngCore from '@angular/core'

import * as tag from '../../../tag'
import * as _default from '../standard'

/** TODO:  */
@ngCore.Component({
  imports: [tag.Component],
  selector: 'atn-list-content',
  standalone: true,
  styleUrl: './component.scss',
  templateUrl: './component.html',
})
export class Component {
  /** TODO: */
  public readonly valueSg = ngCore.input.required<readonly unknown[]>({
    alias: 'value',
  })

  /**
   * Value as an array of strings so that we can pass it to {@link tag.Component ds-tag} component
   */
  public readonly valueAsStringSg = ngCore.computed((value = this.valueSg()) =>
    value.map(String),
  )
}
